
// Third Party
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace, Getter, State } from 'vuex-class';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { get } from "lodash";

// Types
import { Map } from "@/store/map-setup/types";
import { VueBootstrapField, UserPermissions, FeaturesList } from '@/store/types';

// Sv Components
import SureViewIcon from "@/components/SureViewIcon.vue"

// Namespaces
const MapSetupStore = namespace("mapSetup");

@Component({
	components: {
		"vue-perfect-scrollbar": VuePerfectScrollbar,
		"sureview-icon": SureViewIcon,
	}
})
export default class MapManagementModal extends Vue {
    // -- Props -- //
    @Prop({ default: false, type: Boolean }) isVisible: boolean;
    @Prop({ default: false, type: Boolean }) isLoading: boolean;

    // -- Vuex -- //
    @State featuresList: FeaturesList;
    @Getter getPermissions: UserPermissions;
    
	@MapSetupStore.State unconvertedMaps!: Map[];

    // -- Properties -- //
    private fields: VueBootstrapField[] = [
        { key: 'title', label: 'Title', sortable: true },
        { key: 'actions', label: 'Actions', sortable: false }
    ];

    /**
	 * Feature flag check and permission check for converting maps
	 */
	public get canConvertMaps(): boolean {
		return get(this.featuresList, ["MapSetup", "MapConversion"], false) && (this.getPermissions.isAdmin || this.getPermissions.canEditMaps);
	}

    /**
	 * Feature flag and permission check for managing maps
	 */
	private get canManageMaps(): boolean {
		return get(this.featuresList, ["MapSetup", "MapManagement"], false) && (this.getPermissions.isAdmin || this.getPermissions.canEditMaps);
	}

    private displayConfirmation(maptoDelete: Map): void
    {
        this.$emit("display-confirmation", maptoDelete);
    }

    private cancelModal(): void
    {
        this.$emit("cancel");
    }

    private convertMap(map: Map)
    {
        this.$emit("hide-map-management-modal");
        this.$emit("convert-map", map);
    }
}
